import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataTask2000To2099Service {

  constructor() { }
}
